<template>
  <section class="d-flex align-items-center" id="wrap">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <h1>Welcome!</h1>
          <h2>VERIFY A TRIDENT CARD IN THREE EASY STEPS</h2>
        </div>
        <div class="col-12" id="steps">
          <div class="row justify-content-center">
            <div class="col-2 text-center">
              <h3>1</h3><img class="img-fluid" src="../assets/img/step1.svg" alt="">
              <p>Insert the card into the reader</p>
            </div>
            <div class="col-2 d-flex align-items-center">
              <div class="line"></div>
            </div>
            <div class="col-2 text-center">
              <h3>2</h3><img class="img-fluid" src="../assets/img/step2.svg" alt="">
              <p>Authenticate with the card's Pin</p>
            </div>
            <div class="col-2 d-flex align-items-center">
              <div class="line"></div>
            </div>
            <div class="col-2 text-center">
              <h3>3</h3><img class="img-fluid" src="../assets/img/step3.svg" alt="">
              <p>Access the card's information</p>
            </div>
          </div>
        </div>
        <div class="col-12" id="button-ok" @click="step1"><a class="btn btn-comenzar" href="#">Start</a></div>
      </div>
    </div>
  </section>
</template>

<script>
import {hub} from "@/assets/js/iSCertHub";

export default {
  name: "MainContent",
  methods: {
    step1(){

      let value = {"operation": "DETECTED_DEVICES" }
      let param = JSON.stringify(value)
      console.log("method one")
      hub.caller("nid-reader")
          .value(param)
          .onFail(() =>{
            alert("Fallo al conectarse al hub ¿Seguro que está instalado?");
          })
          .call((obj) =>{
            console.log(obj)
            console.log(JSON.stringify(obj,null,4))
            console.log(obj.data.devices)
            console.log(obj.data.devices.length)

            if(obj.data.devices.length != 0) {
              this.$emit('nextStep', 'StepOne')
            } else{
              obj.message = "No card reader device was detected";
              this.$emit('data',obj)
              this.$emit('nextStep','StepError')
            }
          })
    }
  },
  props:{
    data: {}
  },
  emits: ['nextStep']
}
</script>

<style scoped>

</style>